import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadTags } from 'redux/reducers/style/actions';
import {
    clearError,
    saveMoodboardNew,
    stylingRoomClearResult
} from 'redux/reducers/stylingRoom/actions';
import { changeModal, toggleModal } from 'store/ui/actions';

import SaveMoodboard from './SaveMoodboard';

const mapStateToProps = ({
    ui: { redirectUrl },
    style: { loading, tags },
    stylingRoom: { loading: stylingRoomLoading, result, gender, styleRequest, error }
}) => ({
    loading,
    stylingRoomLoading,
    styleRequest,
    tags,
    result,
    gender,
    redirectUrl,
    error
});

const mapDispatchToProps = (dispatch) => ({
    loadTags: (gender, type) => dispatch(loadTags(gender, type)),
    saveMoodboard: (info) => dispatch(saveMoodboardNew(info)),
    clearResult: () => dispatch(stylingRoomClearResult()),
    toggleModal: (data) => toggleModal(dispatch, data),
    changeModal: (data) => changeModal(dispatch, data),
    clearError: () => dispatch(clearError(dispatch))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SaveMoodboard));
